import React, {ReactNode} from 'react';
import {Card, CardBody} from 'reactstrap';

interface IProps {
  children: ReactNode
  isLoading: boolean
  title: string
  actions?: ReactNode
  disableCardBackgroundColor?: boolean
  hasError?: boolean
  errorMessage?: string
}
export const CardComponent = (props: IProps) => {
  const {title, isLoading, actions, disableCardBackgroundColor, hasError, errorMessage} = props;
  const styles = {backgroundColor: 'white'}
  if (disableCardBackgroundColor) {
    styles.backgroundColor = 'transparent';
  }
  return (
    <Card style={styles}>
      <CardBody>
        <span className="card-title">
          {title}&nbsp;&nbsp;
          {isLoading &&
            <i id="loadingTable" className="fa fa-cog fa-spin" />
          }
        </span>
        {hasError
          ? <div
              className="drilldown-panel-error"
              role="alert"
              style={{padding: '1.5rem', textAlign: 'center', color: '#a94442'}}
            >
              {errorMessage || 'This panel could not be loaded. Please try again.'}
            </div>
          : props.children
        }
      </CardBody>
      {(!isLoading && !hasError && actions) && // don't show actions when data is loading or errored
        <div className="card-action">
          {actions}
        </div>
      }
    </Card>
  );
};
